import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';
import mainTpl from './templates/main.html';
import plantTpl from './templates/plant.html';
import {TonsDashboardMainCtrl, TonsDashboardPlantCtrl} from './ctrls.js';

@Module({
    name: 'app.tonsDashboard.routing',
    modules: [
        BaseRoute,
    ],
})
@State({
    name: 'r.in.top.tonsDashboard',
    url: '/tonnage',
    template: mainTpl,
    controller: TonsDashboardMainCtrl,
    ncyBreadcrumb: {
        label: 'Tonnage',
        parent: 'r.in.top',
    },
    data: {
        permissions: {
            only: [
                'main.view_ticket',
            ],
        }
    },
})
@State({
    name: 'r.in.top.tonsDashboard.plant',
    url: '/{companyId:int}',
    controller: TonsDashboardPlantCtrl,
    template: plantTpl,
    ncyBreadcrumb: {
        skip: true,
    },
    data: {
        permissions: {
            only: [
                'main.view_ticket',
            ],
        }
    },
})
export default class States {}



// WEBPACK FOOTER //
// ./src/app/dashboard/tons/routing.js